
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iit-news/[slug]",
      function () {
        return require("private-next-pages/iit-news/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iit-news/[slug]"])
      });
    }
  